import {
  IonButton,
  IonButtons,
  IonChip,
  IonContent,
  IonHeader,
  IonModal,
  IonToolbar
} from "@ionic/react";
import React, {useEffect, useState} from "react";
import {TimeType} from "../common/constants";
import {timeOfDateString, toTimeHm} from "../common/TimeUtils";
import "./TimeInput.css"
import TimeInputSelection from "./TimeInputSelection";


const currentTime = () => {
  let d = new Date()
  let a = timeOfDateString(d.getUTCHours() + ":" + d.getUTCMinutes());
  return a;
}

export const TimeInput = ({value, type, id, min=null, timeChange= f=>f, disabled=false}) => {

  const normalize = (v) => (v != null && v !== "" ? toTimeHm(v) : v);

  const [selectedDate, setSelectedDate] = useState(() => normalize(value));
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setSelectedDate(normalize(value));
  }, [value]);

  //* Value to server: HH:mm (useTowManagement / AeroTowDetail use convTime → HH:mm:ss)
  const onChange = (v) => {
    setOpen(false);
    if (!v) {
      return
    }
    const hm = normalize(v);
    setSelectedDate(hm);
    timeChange(id, type, hm);
  };

  const changeToNone = () => {
    setOpen(false);
    setSelectedDate(undefined);
    timeChange(id, type, undefined);
  };

  /*
  const refreshValue = () => {
    setSelectedDate(currentTime()); // Update selectedDate with the current time
  };
  */

  const cancel = () => {
    //inputEl.current.value = null;
    setTimeout(() => {setOpen(false);},
        0);
  }

  const confirm = () => {
    onChange(selectedDate);
  }
  //console.log("TimeInput: value=" + value + " selectedDate=" + selectedDate + " open=" + open);

  const getParams = () => {
    const initial = selectedDate ? normalize(selectedDate) : currentTime();
    return {
      height: 35,
      seperator: true,
      use12Hours: false,
      initialValue: initial,
      pickerDefaultValue: currentTime(),
      min: min ? normalize(min) : min,
      setSelectedDate: setSelectedDate ? setSelectedDate : currentTime()
    }
  };

  const openInput = () => {
    if (!value) {
      setSelectedDate(currentTime());
    }
    setOpen(true);
  }

  const displayValue = normalize(value);

  return (
        <>
          { disabled ?
            <div className={'show-only-time'}>
              <span className={'non-nullable'}>{displayValue}</span>
            </div>

            :
            <div>
              <IonChip className={'show-only-time'} onClick={() => openInput()}>
              {displayValue ?
                  <span className={'non-nullable' + (open ? ' open': '')}>{displayValue}</span>
                  :
                  <span className={'nullable blinking'}>{
                    type === TimeType.LANDING_GLIDER_TIME ? "přistání" : type === TimeType.LANDING_TOWING_TIME ? "přistání" : "start"}</span>
              }
              </IonChip>
            </div>
          }
          <IonModal isOpen={open} canDismiss={true} onWillDismiss={() => cancel()}
                    cssClass='my-custom-modal'>
            <IonHeader>
              <IonToolbar>
                <IonButtons slot="start" className={'flex-buttons-space'}>
                  <IonButton onClick={() => cancel() }  fill="solid">Zrušit</IonButton>
                  { type !== TimeType.START_TIME && <IonButton  fill="solid" strong={true} onClick={() => changeToNone()}>
                    Žádný
                  </IonButton>
                  }
                  <IonButton strong={true} onClick={() => confirm()} fill="solid">
                    Uložit
                  </IonButton>
                  {/*<IonButton strong={true} onClick={() => refreshValue()}>
                    refresh
                  </IonButton>
                  */}
                </IonButtons>
              </IonToolbar>
            </IonHeader>
            <IonContent>
              {open && !disabled &&
                    <TimeInputSelection {...getParams()} />
              }
            </IonContent>
          </IonModal>
        </>
)
}